import { connect } from 'react-redux'
import PersonalInformation from '../component/PersonalInformation'

const mapStateToProps = state => {
  return {
    activeStep: state.activeStep,
    start: state.start,
    person: state.person,
    addresses: state.addresses
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps) (PersonalInformation);
